import React from 'react';

import SearchFilter from 'components/Filters/SearchFilter';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

const SubNavigation = ({filters, setFilter}: SubNavigationProps) => (
  <div className="SubNavigation colab-sidepadding-2 colab-centered">
    <SearchFilter
      value={filters.search}
      onChange={(search: string) => setFilter('search', search)}
    />
  </div>
);

export default SubNavigation as React.ComponentType<SubNavigationProps>;
